"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCarUndergroundGarage32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h32v32H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M6 24.852V8.462c0-.726.471-1.314 1.053-1.314h17.894c.582 0 1.053.588 1.053 1.313v16.39m-2.501-2.74v1.674c0 .308-.28.558-.625.558H21c-.345 0-.625-.25-.625-.558v-1.674m-8.747 0v1.674c0 .308-.28.558-.625.558H9.13c-.345 0-.625-.25-.625-.558v-1.674m1.287-2.247h2.356m7.757 0h2.356m1.239-2.345-2.335-4.822a.629.629 0 0 0-.57-.344h-9.185a.629.629 0 0 0-.57.344L8.504 17.52v4.592H23.5V17.52Zm-14.995.08H23.5", stroke: "currentColor" })] })) }))); };
exports.default = SvgCarUndergroundGarage32;
